import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontFredoka, theme } from "@product/scmp-sdk";

import { Heading } from "scmp-app/components/posties/brochure-homepage/heading";

import Heart from "./heart.svg?url";
import SandTwo from "./sand-two.svg?url";
import { WhyPostiesItem } from "./why-posties-item";

export const Container = styled.div`
  position: relative;
  scroll-margin-top: 66px;
  ${theme.breakpoints.up("desktop")} {
    scroll-margin-top: 100px;
  }
`;

export const HeaderContainer = styled.div`
  position: relative;

  display: table;

  margin-block-end: 48px;
  margin-inline: auto auto;
  padding-block-start: 40px;

  text-align: center;
  &::after {
    position: absolute;
    inset-block-start: 17%;
    inset-inline-end: -223px;
    content: "";

    display: none;

    inline-size: 167px;
    block-size: 98px;

    background-image: url(${Heart});

    ${theme.breakpoints.up("desktop")} {
      inset-inline-end: -185px;

      display: block;
    }
    ${theme.breakpoints.up("largeDesktop")} {
      inset-inline-end: -223px;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block-start: 64px;
  }
`;

export const Header = styled(Heading)`
  margin-block-end: 20px;
`;

export const Description = styled.div`
  max-inline-size: 300px;

  font-size: 18px;
  font-family: ${fontFredoka};
  line-height: 22px;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 600px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }

  span {
    display: inline-block;

    padding-inline: 10px;

    color: #ffffff;
    font-weight: 600;
    font-size: 24px;
    line-height: 33.6px;

    border-radius: 2px;

    background-color: #eb4d42;

    ${theme.breakpoints.up("desktop")} {
      font-size: 28px;
      line-height: 39.2px;
    }
  }
`;

export const StyledWhyPostiesItem = styled(WhyPostiesItem)`
  max-inline-size: 335px;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 560px;
  }
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 246px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 360px;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-block-end: 40px;
  padding-inline: 20px;

  overflow: hidden;

  ${theme.breakpoints.up("desktop")} {
    align-items: flex-start;
  }

  ${StyledWhyPostiesItem} {
    &:not(&:last-child) {
      margin-block-end: 30px;
      ${theme.breakpoints.up("desktop")} {
        margin-block-end: 0;
        margin-inline-end: 30px;
      }
    }
  }
  ${theme.breakpoints.up("desktop")} {
    flex-direction: row;

    padding-block-end: 64px;
  }
`;

export const SandStyle = css`
  position: relative;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export const StyledSandTwo = styled.div`
  ${SandStyle}
  background-image: url(${SandTwo});

  aspect-ratio: 1440/156;
`;
